import React from 'react';

import { ConsultationCardSkeleton } from 'components';
import { Box, Spinner, Typography } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { useTranslation } from 'react-i18next';

export const ConsultationCardLoading: React.FC = () => {
  const { t } = useTranslation('consultation_card');
  const defaultSelectionCount = 10;
  return (
    <Box position='relative'>
      {Array.from(Array(defaultSelectionCount).keys()).map((_, index) => (
        <ConsultationCardSkeleton key={index} />
      ))}
      <Box
        position='absolute'
        zIndex={2}
        top='13%'
        left='60%'
        border='1px solid'
        borderColor={COLOURS.gray[300]}
        transform={{ base: 'translate(-61%,-50%)', lg: 'translate(-70%,-50%)' }}
        background={COLOURS.white}
        width='353px'
        mb={6}
        py={10}
        textAlign='center'
        boxShadow='0px 0px 12px -8px rgba(0,0,0,0.35)'
      >
        <Typography mb={5}>
          <h3>{t('loading', 'Loading')}</h3>
        </Typography>
        <Spinner size='xl' color={COLOURS.blue[400]} />
      </Box>
    </Box>
  );
};
